<template>
    <div class="image-editor d-flex flex-column flex-lg-row">
        <div class="image-container d-flex">
            <image-editor-canvas :editor-nav="$refs['editor-nav']"></image-editor-canvas>
        </div>

        <image-editor-nav ref="editor-nav"></image-editor-nav>

        <portal-target name="modal-destination" multiple></portal-target>
    </div>
</template>

<script>
import ImageEditorNav from "./image-editor/ImageEditorNav";
import ImageEditorCanvas from "./image-editor/ImageEditorCanvas";
import {useImageEditorStore} from "./image-editor/store";

export default {
    components: {ImageEditorCanvas, ImageEditorNav },
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
        }
    },
    mounted() {
        this.store.editorNav = this.$refs["editor-nav"].$el;
    },
}
</script>
